import React, { useRef, useState, useEffect } from 'react';

import ThreeCanvasErrorBoundary from './ThreeCanvasErrorBoundary';
import {ThreeScene} from './ThreeScene';

const ThreeCanvas = ({pieceType,meshName, color, threeParams, admin}) => {

  const [expanded, setExpanded] = useState(false);

  const [hasError, setError] = useState(false)

  // things in the scene we can manipulate

  const [isAnimating, setAnimating] = useState(true)

  const mount = useRef(null)
  const controls = useRef(null)

  const genericError = (error)=>{
    //console.log( "called generic hook promise catch error");
    // special hack to get this hook back out to error boundary
    // https://github.com/facebook/react/issues/14981#issuecomment-468460187
    // set error is created inside the component
    setError((hooksErr)=>{
      console.log( "inside THREE generic err", hooksErr, error );
      throw new Error(error);
    });
  };

  /* ==========================================================
   * here we initialize everything now that the DOM is prepared
   * ==========================================================
   */

  useEffect(() => {
    console.log('[Preview expanded]', { expanded, hasControls: !!controls.current?.handleResize });
    if( controls && controls.current && controls.current.handleResize ){
      controls.current.handleResize()
    }
  }, [expanded])

  useEffect(() => {
    const {handleResize, renderer} = ThreeScene(mount, controls, pieceType, meshName, color, genericError, window.innerWidth, threeParams, admin );

    window.addEventListener('resize', handleResize);

    return () => {
      controls.current?.stop()
      window.removeEventListener('resize', handleResize)
      if (mount.current?.contains(renderer.domElement)) {
        mount.current.removeChild(renderer.domElement)
      }
    }
  }, [])

  // end use effect

  // look for the side effects of setting size and color.
  // when they are, call methods on them
  useEffect(() => {
    if (!controls.current?.sceneReady) return;
    if (isAnimating) {
      controls.current.start()
    } else {
      controls.current.stop()
    }
  }, [isAnimating])


  useEffect(() => {
    if (!controls.current?.sceneReady) return;
    if( admin === true ){
      controls.current.rerenderMesh(meshName, color, threeParams);
    }else{
      controls.current.replaceMesh(meshName, color, threeParams)
    }
  }, [meshName, color, threeParams])

  const expandedCN = expanded ? 'expand-vis' : 'vis';

  const expandBtnTxt = expanded ? <ExitFullScreenIcon/> : <FullScreenIcon/>;

  return (<>
          <div ref={mount} className={expandedCN}>
            <button className="expand-btn" onClick={_=>setExpanded(!expanded)}>
              {expandBtnTxt}
            </button>
          </div>
        </>);
  /*
  return (<div>
          <div className="vis" ref={mount} />
          <button onClick={() => setAnimating(!isAnimating)}>stop anim</button>
        </div>);
  */

}

const Preview = ({threeParams, pieceType, meshName, color, admin, expanded,}) => {

  return (
    <ThreeCanvasErrorBoundary>
      <ThreeCanvas
        threeParams={threeParams}
        pieceType={pieceType}
        meshName={meshName}
        color={color}
        admin={admin}
        expanded={expanded}
      />
    </ThreeCanvasErrorBoundary>
  );
}

const FullScreenIcon = () => {
  return (<svg version="1.1" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg"><title/><desc/><defs/><g fill="none" fill-rule="evenodd" id="Page-1" stroke="none" stroke-width="1"><g fill="#000000" id="Core" transform="translate(-215.000000, -257.000000)"><g id="fullscreen" transform="translate(215.000000, 257.000000)"><path d="M2,9 L0,9 L0,14 L5,14 L5,12 L2,12 L2,9 L2,9 Z M0,5 L2,5 L2,2 L5,2 L5,0 L0,0 L0,5 L0,5 Z M12,12 L9,12 L9,14 L14,14 L14,9 L12,9 L12,12 L12,12 Z M9,0 L9,2 L12,2 L12,5 L14,5 L14,0 L9,0 L9,0 Z" id="Shape"/></g></g></g></svg>);
};

const ExitFullScreenIcon = () => {
  return (<svg version="1.1" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg"><title/><desc/><defs/><g fill="none" fill-rule="evenodd" id="Page-1" stroke="none" stroke-width="1"><g fill="#000000" id="Core" transform="translate(-257.000000, -257.000000)"><g id="fullscreen-exit" transform="translate(257.000000, 257.000000)"><path d="M0,11 L3,11 L3,14 L5,14 L5,9 L0,9 L0,11 L0,11 Z M3,3 L0,3 L0,5 L5,5 L5,0 L3,0 L3,3 L3,3 Z M9,14 L11,14 L11,11 L14,11 L14,9 L9,9 L9,14 L9,14 Z M11,3 L11,0 L9,0 L9,5 L14,5 L14,3 L11,3 L11,3 Z" id="Shape"/></g></g></g></svg>)
};

export default Preview;
